/**
 * @generated SignedSource<<4b46eab3484de2a0f434cb62e4c6cbb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConnectTalentFacebookInput = {
  clientMutationId?: string | null | undefined;
  facebookPageId?: string | null | undefined;
  facebookProfileUrl?: string | null | undefined;
  token?: string | null | undefined;
};
export type TalentFacebookPageMutation$variables = {
  input: ConnectTalentFacebookInput;
};
export type TalentFacebookPageMutation$data = {
  readonly connectTalentFacebook: {
    readonly talentProfile: {
      readonly facebookPageName: string | null | undefined;
      readonly facebookPageUrl: string | null | undefined;
      readonly facebookPageVerified: boolean;
      readonly facebookProfileUrl: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type TalentFacebookPageMutation = {
  response: TalentFacebookPageMutation$data;
  variables: TalentFacebookPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConnectTalentFacebookPayload",
    "kind": "LinkedField",
    "name": "connectTalentFacebook",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TalentProfile",
        "kind": "LinkedField",
        "name": "talentProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookProfileUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookPageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookPageName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookPageVerified",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TalentFacebookPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TalentFacebookPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e79e15e65abb62deefc6e8ca8bede666",
    "id": null,
    "metadata": {},
    "name": "TalentFacebookPageMutation",
    "operationKind": "mutation",
    "text": "mutation TalentFacebookPageMutation(\n  $input: ConnectTalentFacebookInput!\n) {\n  connectTalentFacebook(input: $input) {\n    talentProfile {\n      id\n      name\n      facebookProfileUrl\n      facebookPageUrl\n      facebookPageName\n      facebookPageVerified\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de65b76cbefe9cc6087bf573ef771247";

export default node;
